import { Const } from '../lib/const.cls'

import * as RxFactory from '../../../../../store/api/rx-factory'

// vue-webapp server address @see config/prod.env.js, dev.env.js, test.env.js 
// export const FINVIEW_ROOT = process.env.LOCAL_TRADER_SERVER_FULL_ADDRESS
export const FINVIEW_ROOT = process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS


import { GET_TOKEN } from '../../../../../types'
export const REDIRECT_BASE_PATH = "/"

export const EP_REGISTER_STEP1 = "/api/leads/register"
export const EP_REGISTER_STEP2 = "/api/leads/condition"
export const EP_REGISTER_STEP3 = "/api/user/plan/add"
export const EP_REGISTER_STEP4 = "/api/leads/appointment/book"
export const EP_CALL_REQUEST = "/api/leads/on/call"
export const EP_CONTACT_US = "/api/leads/contactus"
export const EP_GET_AVAILABLE_SLOTS = "/api/availability/slots"
export const EP_GET_REGISTER_DATA = "/api/get/leads/info"
export const EP_DIABETES_FORM = "/api/diabetes/program/register"
export const EP_CHECK_EMAIL = "/api/check/email"
export const EP_GET_PAYU_REQUEST = "/api/service/payu/request/initiate"
export const EP_GET_TIME_SLOTS = "/api/user/get/slots"
export const EP_FIND_PROGRAM = "/api/user/intensive/diabetes/program"


const Swal = require('sweetalert2')

let tempTransactionid = ""

export const actions = {
	//==================================================================

	[Const.RUN_DIABETES_FORM]({ commit, state, getters, dispatch }, req) {
		try {
			const self = this;
			let expressRemote = FINVIEW_ROOT + EP_DIABETES_FORM
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {
				if (!error) {
					req.localParams.parameter.step = 3
					// req.localParams.parameter.step = 3
				} else {
					req.localParams.parameter.alertMsg = resultSet.res_data
					// _messageDisplayFunction(req.localParams.parameter,resultSet.res_data,'error')	
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
	},

	[Const.RUN_CHECK_EMAIL]({ commit, state, getters, dispatch }, req) {
		try {
			const self = this;
			let expressRemote = FINVIEW_ROOT + EP_CHECK_EMAIL
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {
				if (!error) {
					req.localParams.parameter.step = 2
				} else {
					req.localParams.parameter.alertMsg = resultSet.res_data.msg
					// _messageDisplayFunction(req.localParams.parameter,resultSet.res_data,'error')	
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
	},
	[Const.RUN_REGISTER_STEP1]({ commit, state, getters, dispatch }, req) {
		try {
			const self = this;
			let expressRemote = FINVIEW_ROOT + EP_REGISTER_STEP1
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {
				if (!error) {
					if (resultSet.res_data.lastInsertId && resultSet.res_data.message != 'Your email Id is already exist.') {//new user
						localStorage.setItem("lastInsertId", resultSet.res_data.lastInsertId);
						req.localParams.parameter.$router.push({ path: '/step2', query: { gender: resultSet.res_data.gender } })
					}
					else if (!resultSet.res_data[0].lastInsertId && resultSet.res_data[0]._id && resultSet.res_data[0].step && !resultSet.res_data[0].membership_plan && resultSet.res_data[0].message == 'Your email Id is already exist.') { //existing user without selecting plan
						localStorage.setItem("lastInsertId", resultSet.res_data[0]._id);
						if (parseInt(resultSet.res_data[0].step) != 2) {
							let step = '/step' + (parseInt(resultSet.res_data[0].step) + 1)
							req.localParams.parameter.$router.push({ path: step, query: { gender: resultSet.res_data[0].gender } })
						} else {
							req.localParams.parameter.$router.push({ path: '/step4' })
						}
						_messageDisplayFunction(req.localParams.parameter, resultSet.res_data[0].message, 'error')
					} else if (!resultSet.res_data[0].lastInsertId && resultSet.res_data[0]._id && resultSet.res_data[0].step && resultSet.res_data[0].membership_plan && resultSet.res_data[0].message == 'Your email Id is already exist.') { //existing user with already select plan
						localStorage.setItem("lastInsertId", resultSet.res_data[0]._id);
						let step = '/step' + (parseInt(resultSet.res_data[0].step) + 1)
						//req.localParams.parameter.$router.push({path: step ,query:{plan : resultSet.res_data[0].membership_plan}})
						req.localParams.parameter.$router.push({ path: step })
						_messageDisplayFunction(req.localParams.parameter, resultSet.res_data[0].message, 'error')
					}
					else if (!resultSet.res_data[0].lastInsertId && resultSet.res_data[0]._id && !resultSet.res_data[0].step && resultSet.res_data[0].message == 'Your email Id is already exist.') { //old user without this concept 
						_messageDisplayFunction(req.localParams.parameter, resultSet.res_data[0].message, 'error')
					}
				} else {
					_messageDisplayFunction(req.localParams.parameter, resultSet.res_data, 'error')
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
	},

	[Const.RUN_REGISTER_STEP2]({ commit, state, getters, dispatch }, req) {
		try {
			const self = this;
			let expressRemote = FINVIEW_ROOT + EP_REGISTER_STEP2
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {
				if (!error) {
					req.localParams.parameter.$router.replace('/step4')
				} else {
					_messageDisplayFunction(req.localParams.parameter, resultSet.res_data, 'error')
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
	},

	[Const.RUN_REGISTER_STEP3]({ commit, state, getters, dispatch }, req) {
		try {
			const self = this;
			let expressRemote = FINVIEW_ROOT + EP_REGISTER_STEP3
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {
				if (!error) {
					req.localParams.parameter.$router.push({ path: '/step4', query: { 'plan': req.localParams.parameter.selected_plan } })
				} else {
					_messageDisplayFunction(req.localParams.parameter, resultSet.res_data, 'error')
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
	},


	[Const.RUN_REGISTER_STEP4]({ commit, state, getters, dispatch }, req) {
		try {
			const self = this;
			let expressRemote = FINVIEW_ROOT + EP_REGISTER_STEP4
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {
				if (!error) {
					gtag("event", "conversion", {
						send_to: "AW-10976977777/Uk3qCO32n9oDEPHGnfIo",
					});

					//req.localParams.parameter.getPaymentRequestdata()
					req.localParams.parameter.$router.replace('/step5')
				} else {
					_messageDisplayFunction(req.localParams.parameter, resultSet.res_data, 'error')
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
	},

	[Const.RUN_CALL_REQUEST]({ commit, state, getters, dispatch }, req) {
		try {
			const self = this;
			let expressRemote = FINVIEW_ROOT + EP_CALL_REQUEST
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {
				if (!error) {
					// req.localParams.parameter.reset()
					req.localParams.parameter.congo = true
					//_messageDisplayFunction(req.localParams.parameter,'successfully','success')																	
				} else {
					_messageDisplayFunction(req.localParams.parameter, resultSet.res_data, 'error')
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
	},

	[Const.RUN_FIND_PROGRAM_FORM]({ commit, state, getters, dispatch }, req) {
		return new Promise((resolve, reject) => {
			try {
				let expressRemote = FINVIEW_ROOT + EP_FIND_PROGRAM
				_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {
					if (!error) {
						gtag("event", "conversion", {
							send_to: "AW-10976977777/Uk3qCO32n9oDEPHGnfIo",
						});
						resolve()
					} else {
						_messageDisplayFunction(req.localParams.parameter, resultSet.res_data, 'error')
						reject(resultSet.res_data)
					}
				});
			} catch (ex) {
				console.log("In e", ex)
				_handleErrorResponse(ex, commit)
			}
		})
	},

	[Const.RUN_CONTACT_US]({ commit, state, getters, dispatch }, req) {
		try {
			const self = this;
			let expressRemote = FINVIEW_ROOT + EP_CONTACT_US
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {
				if (!error) {
					req.localParams.parameter.reset()
					_messageDisplayFunction(req.localParams.parameter, 'message sent successfully', 'success')
				} else {
					_messageDisplayFunction(req.localParams.parameter, resultSet.res_data, 'error')
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
	},

	[Const.RUN_GET_REGISTER_DATA]({ commit, state, getters, dispatch }, req) {
		try {
			const self = this;
			let expressRemote = FINVIEW_ROOT + EP_GET_REGISTER_DATA
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {
				if (!error) {
					commit(Const.SET_REGISTER_DATA, resultSet.res_data)
				} else {
					commit(Const.SET_REGISTER_DATA, [])
					_messageDisplayFunction(req.localParams.parameter, resultSet.res_data, 'error')
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
	},

	[Const.RUN_PAYU_REQUEST_INITIATE]({ commit, state, getters, dispatch }, req) {
		try {
			const self = this;
			let expressRemote = FINVIEW_ROOT + EP_GET_PAYU_REQUEST
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {
				if (!error) {
					if (Object.keys(resultSet.res_data).length > 0) {
						commit(Const.SET_PAYU_REQUEST_INITIATE, resultSet.res_data)
						window.open(req.localParams.parameter.paymentLink(), '_blank', 'width=800, height=900');
					}
				} else {
					commit(Const.SET_PAYU_REQUEST_INITIATE, {})
					_messageDisplayFunction(req.localParams.parameter, resultSet.res_data, 'error')
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
	},

	[Const.RUN_GET_TIME_SLOTS]({ commit, state, getters, dispatch }, req) {
		try {
			const self = this;
			let expressRemote = FINVIEW_ROOT + EP_GET_TIME_SLOTS
			_vueExecuteProcess(expressRemote, req, commit, getters, (error, resultSet) => {
				if (!error) {
					if (resultSet.res_data.length > 0) {
						commit(Const.SET_TIME_SLOTS, resultSet.res_data)
					} else {
						commit(Const.SET_TIME_SLOTS, [])
					}
				} else {
					commit(Const.SET_TIME_SLOTS, [])
					_messageDisplayFunction(req.localParams.parameter, resultSet.res_data, 'error')
				}
			});
		} catch (ex) {
			console.log("In e", ex)
			_handleErrorResponse(ex, commit)
		}
	},


}


//================================functions=======================================


function _vueExecuteProcess(expressRemote, credentials, commit, getters, callback) {
	try {
		credentials.localParams.parameter.response_msg = ''
		credentials.localParams.parameter.message = ''
		let response_array = [];

		credentials.localParams.parameter.pageLoader = true
		let token = { 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InZwb29uaWFAeW9wbWFpbC5jb20iLCJpYXQiOjE2NDUwODA3MzQsImV4cCI6MjE4NTA4MDczNH0.jhqM6DgN-DXPTyNxpCgP-WN_5M511rPw1RyXolqVUXg' }
		RxFactory.post(expressRemote, credentials.globalParams, token)
			.map(response => response.data)
			.subscribe(data => {
				credentials.localParams.parameter.pageLoader = false
				if ('info' in data) {
					if (data.info === 'OK') {
						response_array.res_data = data.data
						callback(false, response_array)
					} else {
						response_array.res_data = data.msg
						callback(true, response_array)
					}
				}
			},
				e => { _handleErrorResponse(e, commit) })
	} catch (ex) { _handleErrorResponse(ex, commit) }
}

function _cleanUp(commit, msg, status, loaderId) {
	let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
	// toggle loader 'a', 'b', 'c'
	// commit(SET_TOGGLE_LOADER, loaderArr)
	commit("SET_INFO", msg)
}

function _handleErrorResponse(e, commit) {
	let response = { info: 'NOK', msg: 'Service not available' }
	if (typeof e.response === 'undefined') {
		try {
			const statusCheck = e.toString().toLowerCase()
			if (statusCheck.indexOf('network') > -1) {
				response = { info: 'NOK', msg: 'Network Error' }
			}
			console.log("statusCheck", statusCheck)
		} catch (e) { }
	} else {
		console.log("statusCheck", e.response.status)
		response = e.response.data
	}
	_cleanUp(commit, response, response.status)
	if (typeof e.response !== 'undefined') {
		if (e.response.status == 401) {
			let data = {}
			let options = {}
			options.forward = true
			_handleLogout(data, commit, options)
		}
	}
}

function _messageDisplayFunction(getParameter, getMessage, msgType) {
	getParameter.response_msg = msgType
	getParameter.message = getMessage
}

function _handleLogout(data, commit, options) {
	console.log('_handleLogout args', data, options)
	let user = {}
	const state = []
	// set state (user, token)
	//commit(Const.SET_TRADER_BASIC_INFO, state)

	// save state to local storage (user)
	window.sessionStorage.setItem('user_info', "")

	if ('msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	// route back to blockmaze portal
	if (options.forward === true) {
		//window.location.replace("/")
		//options.router.replace({ path : "/prism" })
	}
}


// WEBPACK FOOTER //
// ./src/plugins/giniView/provider/candle-history/store-addons/actions.js